module.exports = __webpack_public_path__ + "static/media/brasilNav.c2d600a9.png";